import React, { Component } from 'react';
import { Menu, Button, Dimmer, Image } from 'semantic-ui-react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import PropTypes from 'prop-types';
import { withTranslation } from "react-i18next";

import spain from '../../images/spain.png';
import uk from '../../images/uk.png';
import fr from '../../images/francia.png';
import i18n from '../../i18n'
import BookingButton from './BookingButton';
import OwnBookingButton from './OwnBookingButton';

import LanguageDropDown from './LanguageDropDown';

// import MenuIcon from '@material-ui/icons/Menu';


import { VERTICAL_MENU_PATHS } from '../../common/constants';

class VerticalMenuNoTranslation extends Component {
  // static propTypes = {};

  state = {};


  handleOpen = () => this.setState({ active: true });
  handleClose = () => this.setState({ active: false });

  spanishCLicked = () => i18n.changeLanguage('es')


  ukCLicked = () => i18n.changeLanguage('en');
  frCLicked = () => i18n.changeLanguage('fr');



  render() {
    const { t } = this.props;
    const keys = {
      menuRooms: "general.menuRooms",
      menuGranada: "general.menuGranada",
      menuGallery: "general.menuGallery",
      menuContact: "general.menuContact",
      menuAbout: "general.menuAbout",
      menuNavigate: "general.menuNavigate",
      menuReglamentoServicios: "general.menuReglamentoServicios"
    }

    const menuTexts = [
      t(keys.menuRooms, { framework: 'React' }),
      t(keys.menuGranada, { framework: 'React' }),
      t(keys.menuGallery, { framework: 'React' }),
      t(keys.menuContact, { framework: 'React' }),
      t(keys.menuAbout, { framework: 'React' }),
      t(keys.menuNavigate, { framework: 'React' }),
      t(keys.menuReglamentoServicios, { framework: 'React' })
    ]

    const { active } = this.state;
    const navigateText = t(keys.menuNavigate, { framework: 'React' });
    return (
      <div className="common-vertical-menu">
        {/* <Button
          content='Show'
          icon='plus'
          labelPosition='left'
          onClick={this.handleOpen}
        /> */}

        <AppBar position="fixed" color="primary">
          <Toolbar>
            <Logo />
            <div className='app-bar-buttons'>
              <LanguageDropDown />
              <OwnBookingButton />
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={this.handleOpen}
              >
                <Button
                  className="hamburguer-button"
                  // content='Show'
                  icon="bars"
                  // labelPosition='right'
                  onClick={this.handleOpen}
                />
              </IconButton>
            </div>

          </Toolbar>
        </AppBar>

        <Dimmer active={active} onClickOutside={this.handleClose} page>
          <Menu className="vertical-menu" vertical>
            {menuTexts.map((item, index) => (
              <Menu.Item>
                {
                  item === navigateText && <a href="http://maps.google.com/?q=oripando hostel granada">{item}</a>
                }
                {
                  item !== navigateText && <Link onClick={this.handleClose} to={VERTICAL_MENU_PATHS[index]}>{item}</Link>
                }
              </Menu.Item>
            ))}
          </Menu>
        </Dimmer>
      </div>
    );
  }
}


const VerticalMenu = withTranslation('common')(VerticalMenuNoTranslation)

export default VerticalMenu;


// WEBPACK FOOTER //
// ./src/features/common/VerticalMenu.js